import { createApp } from 'vue';
import NefToJpgConverter from '../Components/NefToJpgConverter.vue';

const root = document.getElementById('nef-to-jpg-converter');
if (root) {
  createApp(NefToJpgConverter).mount('#nef-to-jpg-converter');
}
